export interface Testimonial {
  text: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    text: 'I was spending three or four hours every Sunday rebuilding sessions for my prenatal clients. Now I open the session library, pick the structure that fits, apply the modifications and I’m done in twenty minutes. The trimester adaptation matrices are the part I use most — I finally stopped second-guessing what to change.',
    author: 'Charlotte Baines',
    role: 'Prenatal fitness coach, 38',
    location: 'Bristol, United Kingdom',
  },
  {
    text: 'I have two certifications and eleven years of training clients, so I honestly didn’t think I needed this. What I actually needed was the structure. The assessment framework and client management tools made my coaching look and feel as professional as it already was.',
    author: 'Melissa Grant',
    role: 'Personal trainer & pre/postnatal specialist, 41',
    location: 'Calgary, Canada',
  },
  {
    text: 'The Session Rescue System saved me twice in my first week. A client arrived exhausted and with no access to the equipment we planned for, and I had a Plan B session open on my tablet in seconds. She never noticed anything changed.',
    author: 'Danielle Okafor',
    role: 'Studio owner & prenatal coach, 34',
    location: 'Austin, United States',
  },
  {
    text: 'What sold me was the exercise library with cues, regressions and substitutions all in one place. I coach six pregnant clients a week and each one needs something slightly different — now the alternatives are already there instead of me searching mid-session.',
    author: 'Sophie Whitcombe',
    role: 'Prenatal strength coach, 29',
    location: 'Melbourne, Australia',
  },
  {
    text: 'The program builder changed how I sell my packages. I can show a client a structured multi-week plan on day one instead of promising I’ll figure the next block out later. Two clients upgraded to 12-week programs the same month.',
    author: 'Rachel Lindqvist',
    role: 'Women’s health personal trainer, 45',
    location: 'Toronto, Canada',
  },
]
